import {
  apiRequest,
  P3KdetailPeriod,
  P3KprocessP3K,
  P3KDownloadDraftSK,
} from "../../../../../services/adapters/kepegawaian/P3KService";

class IndesRepository {
  fetchDetailPeriod = async (query) => {
    return await apiRequest(
      "get",
      P3KdetailPeriod,
      {
        params: query,
      },
      true
    );
  };

  fetchProcess = async (query) => {
    return await apiRequest(
      "post",
      P3KprocessP3K,
      {
        body: query,
      },
      true
    );
  };

  fetchDownloadDraftSK = async (query) => {
    return await apiRequest(
      "get",
      P3KDownloadDraftSK,
      {
        params: query,
      },
      true
    );
  };
}

export default IndesRepository;
